<template>
  <DefaultLayout> Admin </DefaultLayout>
</template>

<script>
import DefaultLayout from "@/layouts/Default";

export default {
  components: {
    DefaultLayout,
  },
};
</script>
